import { EvidenceState } from "@redotech/redo-return-ui/flows/return-flow/evidence";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const EvidenceDetails = memo(function EvidenceDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<EvidenceState>) {
  return (
    <Flex dir="column" gap="md">
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Prompt
        </Text>
        <RedoTextareaInputField
          placeholder="Instructions for what evidence to capture"
          setValue={(prompt) => setState((state) => ({ ...state, prompt }))}
          value={state.prompt}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Notes label (optional)
        </Text>
        <RedoTextInput
          placeholder="e.g. Notes about the damage"
          setValue={(notesLabel) =>
            setState((state) => ({ ...state, notesLabel }))
          }
          value={state.notesLabel ?? ""}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Notes placeholder (optional)
        </Text>
        <RedoTextInput
          placeholder="e.g. Describe what you see…"
          setValue={(notesPlaceholder) =>
            setState((state) => ({ ...state, notesPlaceholder }))
          }
          value={state.notesPlaceholder ?? ""}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Next step
        </Text>
        {stepSelect({
          value: state.next,
          valueChange: (next) => setState((state) => ({ ...state, next })),
          handleIndex: 0,
        })}
      </Flex>
    </Flex>
  );
});
